<template>
  <div>
    <v-row>
      <div v-if="showFormatHint" class="description">
        {{formatHint}}
      </div>
      <ValidationProvider :name="field.key" slim mode="eager" :rules="rules" v-slot="{ errors }">
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          :label="`${placeholder} ${requiredHint}`"
          :error-messages="errors[0]"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
          v-model="password"></v-text-field>
      </ValidationProvider>
    </v-row>
  </div>
</template>

<script>
  import _ from 'lodash';
  import {mdiEye, mdiEyeOff} from '@mdi/js';
  import {
    isCustomRegexValidationRuleAvailable
  } from '@/utils/auth/validation';

  export default {
    name: 'Password',
    props: {
      field: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      password: '',
      showPassword: false,
      icons: {mdiEye, mdiEyeOff},
    }),
    computed: {
      placeholder() {
        return this.field.placeholder
          ? this.$t(this.field.placeholder)
          : this.field.name;
      },
      requiredHint() {
        return this.field.required ? ' *' : '';
      },
      formatHint() {
        const defaultHint = this.field.description
          ? this.field.description
          : '';

        return _.get(
          this.$store.getters.authSettings,
          'password_validator.alert.message',
          defaultHint
        );
      },
      showFormatHint() {
        return this.field.key === 'password';
      },
      rules() {
        const isCustomPasswordRuleAvailable = isCustomRegexValidationRuleAvailable('password_validator');

        const defaultPasswordRule =
          isCustomPasswordRuleAvailable
            ? 'required|min:8|password_validator'
            : 'required|min:8';

        return this.field.key === 'password'
          ? defaultPasswordRule
          : 'required|compareFields:@password';
      },
    },
    watch: {
      password() {
        this.$emit('setAttribute', {
          key: 'password',
          value: this.password,
          identity: false
        });
      }
    }
  }
</script>
